import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  FiChevronRight,
  FiHome,
} from "react-icons/fi";

import { getReferralIncome } from "../../store/slices/fund";

const ReferralIncome = () => {
  const dispatch = useDispatch();

  const { referralIncome, referralIncomeLoading, error } = useSelector(
    (state) => state.fund,
  );

  useEffect(() => {
    dispatch(getReferralIncome());
  }, [dispatch]);

  const referrals = Array.isArray(referralIncome) ? referralIncome : [];

  const formatDate = (date) => {
    if (!date) {
      return "-";
    }

    const parsedDate = new Date(date);

    if (Number.isNaN(parsedDate.getTime())) {
      return "-";
    }

    return parsedDate.toLocaleString("en-IN", {
      dateStyle: "medium",
      timeStyle: "short",
    });
  };

  const formatNumber = (number) => {
    return Number(number || 0).toLocaleString("en-IN");
  };

  return (
    <div className="gi-referral-page">
      <div className="gi-breadcrumb">
        <Link to="/dashboard">
          <FiHome />
          Dashboard
        </Link>

        <FiChevronRight className="gi-breadcrumb-arrow" />

        <span>Income Report</span>
        <FiChevronRight className="gi-breadcrumb-arrow" />

        <span>Referral Income</span>
      </div>

      <section className="gi-referral-table-card">
        <div className="gi-referral-table-wrapper">
          <table className="gi-referral-table">
            <thead>
              <tr>
                <th className="text-center">#</th>

                <th className="text-center">Member</th>

                <th className="text-center">User ID</th>

                <th className="text-center">Referral Income</th>

                <th className="text-center">Income Type</th>

                <th className="text-center">Date</th>

                <th className="text-center">Status</th>
              </tr>
            </thead>

            <tbody>
              {referralIncomeLoading && (
                <tr>
                  <td
                    colSpan="8"
                    className="gi-table-message"
                  >
                    Loading referral income...
                  </td>
                </tr>
              )}

              {!referralIncomeLoading && error && (
                <tr>
                  <td
                    colSpan="8"
                    className="gi-table-message"
                  >
                    {error}
                  </td>
                </tr>
              )}

              {!referralIncomeLoading &&
                !error &&
                referrals.length === 0 && (
                  <tr>
                    <td
                      colSpan="8"
                      className="gi-table-message text-center"
                    >
                      No referral income found
                    </td>
                  </tr>
                )}

              {!referralIncomeLoading &&
                !error &&
                referrals.map((item, index) => {
                  const member = item?.fromUserId || {};

                  return (
                    <tr
                      key={
                        item?._id ||
                        member?.userId ||
                        index
                      }
                    >
                      <td className="text-center">
                        {String(index + 1).padStart(
                          2,
                          "0",
                        )}
                      </td>

                      <td className="text-center">
                        <div className="gi-user-cell">
                          <div>
                            <strong>
                              {member?.name ||
                                "-"}
                            </strong>

                            <small>
                              Direct Referral
                            </small>
                          </div>
                        </div>
                      </td>

                      <td className="text-center">
                        <span className="gi-user-id">
                          {member?.userId || "-"}
                        </span>
                      </td>

                      <td className="text-center">
                        <strong className="gi-income-amount">
                          $
                          {formatNumber(item?.amount)}
                        </strong>
                      </td>


                      <td className="text-center">
                        <span className="gi-income-type">
                          {item?.incomeType?.replaceAll(
                            "_",
                            " ",
                          ) || "-"}
                        </span>
                      </td>



                      <td className="text-center">
                        <span className="gi-date-text">
                          {formatDate(
                            item?.createdAt,
                          )}
                        </span>
                      </td>



                      <td className="text-center">
                        <span
                          className={`gi-status-badge ${item?.status?.toLowerCase() ||
                            ""
                            }`}
                        >

                          {item?.status || "-"}
                        </span>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

export default ReferralIncome;
